import { render, staticRenderFns } from "./CheckboxRow.vue?vue&type=template&id=193f8109"
import script from "./CheckboxRow.vue?vue&type=script&lang=ts"
export * from "./CheckboxRow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports